// Separate axios client for auditor session routes (/api/v1/auditor/*)
// Uses the auditorRefreshToken cookie for auth; stores session JWT in Zustand.
import axios from 'axios';
import { API_BASE_URL } from '@/lib/constants';
import { useAuditorAuthStore } from '@/store/auditor-auth.store';

export const auditorApiClient = axios.create({
  baseURL: `${API_BASE_URL}/auditor`,
  withCredentials: true,
});

// Attach auditor session token to every request
auditorApiClient.interceptors.request.use((config) => {
  const token = useAuditorAuthStore.getState().sessionToken;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401/403, clear auditor session and redirect to appropriate error page
auditorApiClient.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    const code = err.response?.data?.errors?.[0]?.message;

    if (status === 401 || status === 403) {
      useAuditorAuthStore.getState().logout();

      if (code?.includes('revoked')) {
        window.location.href = '/auditor/revoked';
      } else if (code?.includes('expired')) {
        window.location.href = '/auditor/expired';
      } else if (status === 403) {
        window.location.href = '/auditor/forbidden';
      } else {
        window.location.href = '/auditor/activate/';
      }
    }

    return Promise.reject(err);
  },
);
